module.exports = __webpack_public_path__ + "img/MathematicsEx.bc45086f.svg";